import { GridTableColumn, GridTableRecord } from './types'

export const exportGridTableToCsv = (
  columns: GridTableColumn[],
  records: GridTableRecord[]
) => {
  const csvContent = `data:text/csv;charset=utf-8,${columns
    // # sign causes csv to be blank after use
    .map(({ label }: GridTableColumn) => `${label.replace('#', '')}`)
    .join(',')}
    ${records
      .map(recordToInclude =>
        columns
          .map(
            (column: GridTableColumn) =>
              `${recordToInclude[column.recordField]}`
          )
          .join(',')
      )
      .join('\r\n')}`
  window.open(encodeURI(csvContent))
}
